module.exports = __webpack_public_path__ + "img/circle-check.257a0061.svg";